export const formatAddress = (
  postalCode?: string | null,
  city?: string | null,
  street?: string | null
): string => {
  if (!postalCode && !city && !street) {
    return '-'
  }

  const formattedPostalCode = postalCode ? `${postalCode},` : ''
  const formattedCity = city ?? ''
  const formattedStreet = street ?? ''

  return `${formattedPostalCode} ${formattedCity} ${formattedStreet}`.trim()
}
